'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect } from 'react';
import { Button } from '@/components/ui/button';
interface CommentInputProps {
  onSubmit: (content: string) => Promise<void>;
  isSubmitting: boolean;
  placeholder?: string;
}
export function CommentInput(t0) {
  const $ = _c(24);
  const {
    onSubmit,
    isSubmitting,
    placeholder: t1
  } = t0;
  const placeholder = t1 === undefined ? "Write a comment..." : t1;
  const [content, setContent] = useState("");
  const [error, setError] = useState(null);
  const textareaRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (textareaRef.current) {
        textareaRef.current.style.height = "auto";
        textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
      }
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== content) {
    t3 = [content];
    $[1] = content;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== content || $[4] !== onSubmit) {
    t4 = async () => {
      if (!content.trim()) {
        setError("Comment cannot be empty");
        return;
      }
      setError(null);
      ;
      try {
        await onSubmit(content.trim());
        setContent("");
        if (textareaRef.current) {
          textareaRef.current.style.height = "auto";
        }
      } catch (t5) {
        const err = t5;
        setError(err instanceof Error ? err.message : "Failed to post comment");
      }
    };
    $[3] = content;
    $[4] = onSubmit;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const handleSubmit = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e => setContent(e.target.value);
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== content || $[8] !== isSubmitting || $[9] !== placeholder) {
    t6 = <textarea ref={textareaRef} value={content} onChange={t5} placeholder={placeholder} disabled={isSubmitting} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent disabled:bg-gray-50 disabled:cursor-not-allowed resize-none min-h-[80px]" />;
    $[7] = content;
    $[8] = isSubmitting;
    $[9] = placeholder;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== error) {
    t7 = error && <p className="text-sm text-red-600">{error}</p>;
    $[11] = error;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== content || $[14] !== isSubmitting) {
    t8 = isSubmitting || !content.trim();
    $[13] = content;
    $[14] = isSubmitting;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = isSubmitting ? "Posting..." : "Post Comment";
  let t10;
  if ($[16] !== handleSubmit || $[17] !== t8 || $[18] !== t9) {
    t10 = <div className="flex justify-end"><Button onClick={handleSubmit} disabled={t8}>{t9}</Button></div>;
    $[16] = handleSubmit;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t6 || $[22] !== t7) {
    t11 = <div className="space-y-2">{t6}{t7}{t10}</div>;
    $[20] = t10;
    $[21] = t6;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}